export const regionsData = {
"Regions": [
        {
            "name": "Arica y Parinacota",
            "provinces": [
                {
                    "name": "Arica",
                    "districts": [
                        "Arica",
                        "Camarones"
                    ]
                },
                {
                    "name": "Parinacota",
                    "districts": [
                        "Putre",
                        "General Lagos"
                    ]
                }
            ]
        },
        {
            "name": "Tarapacá",
            "provinces": [
                {
                    "name": "Iquique",
                    "districts": [
                        "Iquique",
                        "Alto Hospicio"
                    ]
                },
                {
                    "name": "Del Tamarugal",
                    "districts": [
                        "Huara",
                        "Camiña",
                        "Colchane",
                        "Pica",
                        "Pozo Almonte"
                    ]
                }
            ]
        },
        {
            "name": "Antofagasta",
            "provinces": [
                {
                    "name": "Tocopilla",
                    "districts": [
                        "Tocopilla",
                        "María Elena"
                    ]
                },
                {
                    "name": "El Loa",
                    "districts": [
                        "Calama",
                        "Ollagüe",
                        "San Pedro de Atacama"
                    ]
                },
                {
                    "name": "Antofagasta",
                    "districts": [
                        "Antofagasta",
                        "Mejillones",
                        "Sierra Gorda",
                        "Taltal"
                    ]
                }
            ]
        },
        {
            "name": "Atacama",
            "provinces": [
                {
                    "name": "Chañaral",
                    "districts": [
                        "Chañaral",
                        "Diego de Almagro"
                    ]
                },
                {
                    "name": "Copiapó",
                    "districts": [
                        "Copiapó",
                        "Caldera",
                        "Tierra Amarilla"
                    ]
                },
                {
                    "name": "Huasco",
                    "districts": [
                        "Vallenar",
                        "Freirina",
                        "Huasco",
                        "Alto del Carmen"
                    ]
                }
            ]
        },
        {
            "name": "Coquimbo",
            "provinces": [
                {
                    "name": "Elqui",
                    "districts": [
                        "La Serena",
                        "La Higuera",
                        "Coquimbo",
                        "Andacollo",
                        "Vicuña",
                        "Paihuano"
                    ]
                },
                {
                    "name": "Limarí",
                    "districts": [
                        "Ovalle",
                        "Río Hurtado",
                        "Monte Patria",
                        "Combarbalá",
                        "Punitaqui"
                    ]
                },
                {
                    "name": "Choapa",
                    "districts": [
                        "Illapel",
                        "Salamanca",
                        "Los Vilos",
                        "Canela"
                    ]
                }
            ]
        },
        {
            "name": "Valparaíso",
            "provinces": [
                {
                    "name": "Petorca",
                    "districts": [
                        "La Ligua",
                        "Petorca",
                        "Cabildo",
                        "Zapallar",
                        "Papudo"
                    ]
                },
                {
                    "name": "Los Andes",
                    "districts": [
                        "Los Andes",
                        "San Esteban",
                        "Calle Larga",
                        "Rinconada"
                    ]
                },
                {
                    "name": "San Felipe de Aconcagua",
                    "districts": [
                        "San Felipe",
                        "Putaendo",
                        "Santa María",
                        "Panquehue",
                        "Llaillay",
                        "Catemu"
                    ]
                },
                {
                    "name": "Quillota",
                    "districts": [
                        "Quillota",
                        "La Cruz",
                        "Calera",
                        "Nogales",
                        "Hijuelas",
                        "Limache",
                        "Olmué"
                    ]
                },
                {
                    "name": "Valparaíso",
                    "districts": [
                        "Valparaíso",
                        "Viña del Mar",
                        "Quintero",
                        "Puchuncaví",
                        "Quilpué",
                        "Villa Alemana",
                        "Casablanca",
                        "Concón",
                        "Juan Fernández"
                    ]
                },
                {
                    "name": "San Antonio",
                    "districts": [
                        "San Antonio",
                        "Cartagena",
                        "El Tabo",
                        "El Quisco",
                        "Algarrobo",
                        "Santo Domingo"
                    ]
                },
                {
                    "name": "Isla de Pascua",
                    "districts": [
                        "Isla de Pascua"
                    ]
                }
            ]
        },
        {
            "name": "Metropolitana",
            "provinces": [
                {
                    "name": "Santiago",
                    "districts": [
                        "Santiago",
                        "Cerrillos",
                        "Cerro Navia",
                        "Conchalí",
                        "El Bosque",
                        "Estación Central",
                        "Huechuraba",
                        "Independencia",
                        "La Cisterna",
                        "La Florida",
                        "La Granja",
                        "La Pintana",
                        "La Reina",
                        "Las Condes",
                        "Lo Barnechea",
                        "Lo Espejo",
                        "Lo Prado",
                        "Macul",
                        "Maipú",
                        "Ñuñoa",
                        "Pedro Aguirre Cerda",
                        "Peñalolén",
                        "Providencia",
                        "Pudahuel",
                        "Quilicura",
                        "Quinta Normal",
                        "Recoleta",
                        "Renca",
                        "San Joaquín",
                        "San Miguel",
                        "San Ramón",
                        "Vitacura"
                    ]
                },
                {
                    "name": "Cordillera",
                    "districts": [
                        "Puente Alto",
                        "Pirque",
                        "San José de Maipo"
                    ]
                },
                {
                    "name": "Chacabuco",
                    "districts": [
                        "Colina",
                        "Lampa",
                        "Tiltil"
                    ]
                },
                {
                    "name": "Maipo",
                    "districts": [
                        "San Bernardo",
                        "Buin",
                        "Calera de Tango",
                        "Paine"
                    ]
                },
                {
                    "name": "Melipilla",
                    "districts": [
                        "Melipilla",
                        "Alhué",
                        "Curacaví",
                        "María Pinto",
                        "San Pedro"
                    ]
                },
                {
                    "name": "Talagante",
                    "districts": [
                        "Talagante",
                        "El Monte",
                        "Isla de Maipo",
                        "Padre Hurtado",
                        "Peñaflor"
                    ]
                }
            ]
        },
        {
            "name": "O'Higgins",
            "provinces": [
                {
                    "name": "Cachapoal",
                    "districts": [
                        "Rancagua",
                        "Graneros",
                        "Mostazal",
                        "Codegua",
                        "Machalí",
                        "Olivar",
                        "Requinoa",
                        "Rengo",
                        "Malloa",
                        "Quinta de Tilcoco",
                        "San Vicente",
                        "Pichidegua",
                        "Peumo",
                        "Coltauco",
                        "Coinco",
                        "Doñihue",
                        "Las Cabras"
                    ]
                },
                {
                    "name": "Colchagua",
                    "districts": [
                        "San Fernando",
                        "Chimbarongo",
                        "Placilla",
                        "Nancagua",
                        "Chépica",
                        "Santa Cruz",
                        "Lolol",
                        "Pumanque",
                        "Palmilla",
                        "Peralillo"
                    ]
                },
                {
                    "name": "Cardenal Caro",
                    "districts": [
                        "Pichilemu",
                        "Navidad",
                        "Litueche",
                        "La Estrella",
                        "Marchihue",
                        "Paredones"
                    ]
                }
            ]
        },
        {
            "name": "Maule",
            "provinces": [
                {
                    "name": "Curicó",
                    "districts": [
                        "Curicó",
                        "Teno",
                        "Romeral",
                        "Molina",
                        "Sagrada Familia",
                        "Hualañé",
                        "Licantén",
                        "Vichuquén",
                        "Rauco"
                    ]
                },
                {
                    "name": "Talca",
                    "districts": [
                        "Talca",
                        "Pelarco",
                        "Río Claro",
                        "San Clemente",
                        "Maule",
                        "San Rafael",
                        "Empedrado",
                        "Pencahue",
                        "Constitución",
                        "Curepto"
                    ]
                },
                {
                    "name": "Linares",
                    "districts": [
                        "Linares",
                        "Yerbas Buenas",
                        "Colbún",
                        "Longaví",
                        "Parral",
                        "Retiro",
                        "Villa Alegre",
                        "San Javier"
                    ]
                },
                {
                    "name": "Cauquenes",
                    "districts": [
                        "Cauquenes",
                        "Pelluhue",
                        "Chanco"
                    ]
                }
            ]
        },
        {
            "name": "Ñuble",
            "provinces": [
                {
                    "name": "Diguillín",
                    "districts": [
                        "Chillán",
                        "Bulnes",
                        "Chillán Viejo",
                        "El Carmen",
                        "Pemuco",
                        "Pinto",
                        "Quillón",
                        "San Ignacio",
                        "Yungay"
                    ]
                },
                {
                    "name": "Punilla",
                    "districts": [
                        "San Carlos",
                        "Coihueco",
                        "Ñiquén",
                        "San Fabián",
                        "San Nicolás"
                    ]
                },
                {
                    "name": "Itata",
                    "districts": [
                        "Quirihue",
                        "Cobquecura",
                        "Coelemu",
                        "Ninhue",
                        "Portezuelo",
                        "Ránquil",
                        "Treguaco"
                    ]
                }
            ]
        },
        {
            "name": "Biobío",
            "provinces": [
                {
                    "name": "Biobío",
                    "districts": [
                        "Alto Biobío",
                        "Los Angeles",
                        "Cabrero",
                        "Tucapel",
                        "Antuco",
                        "Quilleco",
                        "Santa Bárbara",
                        "Quilaco",
                        "Mulchén",
                        "Negrete",
                        "Nacimiento",
                        "Laja",
                        "San Rosendo",
                        "Yumbel"
                    ]
                },
                {
                    "name": "Concepción",
                    "districts": [
                        "Concepción",
                        "Talcahuano",
                        "Penco",
                        "Tomé",
                        "Florida",
                        "Hualpén",
                        "Hualqui",
                        "Santa Juana",
                        "Lota",
                        "Coronel",
                        "San Pedro de la Paz",
                        "Chiguayante"
                    ]
                },
                {
                    "name": "Arauco",
                    "districts": [
                        "Lebu",
                        "Arauco",
                        "Curanilahue",
                        "Los Alamos",
                        "Cañete",
                        "Contulmo",
                        "Tirua"
                    ]
                }
            ]
        },
        {
            "name": "La Araucanía",
            "provinces": [
                {
                    "name": "Malleco",
                    "districts": [
                        "Angol",
                        "Renaico",
                        "Collipulli",
                        "Lonquimay",
                        "Curacautín",
                        "Ercilla",
                        "Victoria",
                        "Traiguén",
                        "Lumaco",
                        "Purén",
                        "Los Sauces"
                    ]
                },
                {
                    "name": "Cautín",
                    "districts": [
                        "Temuco",
                        "Lautaro",
                        "Perquenco",
                        "Vilcún",
                        "Cholchol",
                        "Cunco",
                        "Melipeuco",
                        "Curarrehue",
                        "Pucón",
                        "Villarrica",
                        "Freire",
                        "Pitrufquén",
                        "Gorbea",
                        "Loncoche",
                        "Toltén",
                        "Teodoro Schmidt",
                        "Saavedra",
                        "Carahue",
                        "Nueva Imperial",
                        "Galvarino",
                        "Padre las Casas"
                    ]
                }
            ]
        },
        {
            "name": "Los Ríos",
            "provinces": [
                {
                    "name": "Valdivia",
                    "districts": [
                        "Valdivia",
                        "Corral",
                        "Lanco",
                        "Los Lagos",
                        "Mariquina",
                        "Paillaco",
                        "Panguipulli"
                    ]
                },
                {
                    "name": "Ranco",
                    "districts": [
                        "La Unión",
                        "Río Bueno",
                        "Futrono",
                        "Lago Ranco",
                        "Paillaco"
                    ]
                }
            ]
        },
        {
            "name": "Los Lagos",
            "provinces": [
                {
                    "name": "Osorno",
                    "districts": [
                        "Osorno",
                        "San Pablo",
                        "Puyehue",
                        "Rio Negro",
                        "Purranque",
                        "Frutillar"
                    ]
                },
                {
                    "name": "Llanquihue",
                    "districts": [
                        "Puerto Montt",
                        "Calbuco",
                        "Cochamó",
                        "Los Muermos",
                        "Maullín",
                        "Puerto Varas"
                    ]
                },
                {
                    "name": "Chiloé",
                    "districts": [
                        "Castro",
                        "Ancud",
                        "Quinchao",
                        "Dalcahue",
                        "Puqueldón",
                        "Queilén",
                        "Curaco de Vélez"
                    ]
                },
                {
                    "name": "Palena",
                    "districts": [
                        "Chaitén",
                        "Futrono",
                        "Palena"
                    ]
                }
            ]
        },
        {
            "name": "Aysén del General Carlos Ibáñez del Campo",
            "provinces": [
                {
                    "name": "Aysén",
                    "districts": [
                        "Aysén",
                        "Cisnes",
                        "Guaitecas",
                        "Cochrane",
                        "O'Higgins",
                        "Puerto Ibáñez",
                        "Rio Simpson"
                    ]
                },
                {
                    "name": "General Carrera",
                    "districts": [
                        "Chile Chico",
                        "Cerro Castillo",
                        "Rio Ibañez"
                    ]
                }
            ]
        },
        {
            "name": "Magallanes y de la Antártica Chilena",
            "provinces": [
                {
                    "name": "Magallanes",
                    "districts": [
                        "Punta Arenas",
                        "Natales",
                        "Torres del Paine",
                        "Porvenir",
                        "Primavera",
                        "Cabo de Hornos"
                    ]
                },
                {
                    "name": "Antártica Chilena",
                    "districts": [
                        "Antártica",
                        "Isla de Pascua"
                    ]
                }
            ]
        }
    ]
}
